import { useState, type ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { BarChart3, BriefcaseBusiness, Flame, LayoutDashboard, LogOut, Map, Menu, ScanSearch, X } from 'lucide-react';
import { Logo } from './Logo';
import { useAuth } from '../app/AuthContext';
import { useProgress } from '../app/ProgressContext';
import { Celebration } from './Celebration';

const nav = [
  { to: '/dashboard', label: 'Today', icon: LayoutDashboard },
  { to: '/roadmap', label: 'Roadmap', icon: Map },
  { to: '/revision', label: 'Quick revise', icon: ScanSearch },
  { to: '/interviews', label: 'Interviews', icon: BriefcaseBusiness },
  { to: '/progress', label: 'Progress', icon: BarChart3 },
];

export function AppShell({ children }: { children: ReactNode }) {
  const { user, isDemo, logout } = useAuth();
  const { progress, celebration, clearCelebration } = useProgress();
  const [open, setOpen] = useState(false);

  return (
    <div className="app-shell">
      <header className="mobile-header">
        <Logo to="/dashboard" />
        <button className="icon-button" onClick={() => setOpen(!open)} aria-label="Toggle navigation">{open ? <X /> : <Menu />}</button>
      </header>
      <aside className={`sidebar ${open ? 'open' : ''}`}>
        <Logo to="/dashboard" />
        <div className="side-streak"><span><Flame size={20} fill="currentColor" /></span><div><strong>{progress.stats.currentStreak} day streak</strong><small>Keep the chain alive</small></div></div>
        <nav>
          {nav.map(({ to, label, icon: Icon }) => <NavLink key={to} to={to} onClick={() => setOpen(false)}><Icon size={19} /><span>{label}</span></NavLink>)}
        </nav>
        <div className="sidebar-spacer" />
        {isDemo && <div className="demo-pill"><span /> Demo workspace</div>}
        <div className="profile-mini">
          <div className="avatar">{user?.name.slice(0, 1).toUpperCase()}</div>
          <div><strong>{user?.name}</strong><small>Level {progress.stats.level}</small></div>
          <button onClick={logout} title="Log out"><LogOut size={17} /></button>
        </div>
      </aside>
      {open && <button className="nav-backdrop" aria-label="Close navigation" onClick={() => setOpen(false)} />}
      <main className="app-main">{children}</main>
      {celebration && <Celebration day={celebration} onClose={clearCelebration} />}
    </div>
  );
}
